module.exports = __webpack_public_path__ + "media/bg1.ce29fb1b.mp4";